<template>
	<div :class="['cart-item', {'error-item': !data.quantity}, {'error-item': data?.errors?.length}, {'unavailable': unavailable == 0}]" :id="'position-' + data.item.code">
		<div class="cart-item-image">
			<NuxtLink :to="data.item.url_without_domain">
				<BaseUiImage loading="lazy" :data="data.item?.image_thumbs?.['width240-height240']" default="/images/no-image-50.jpg" :alt="data.item.title" />
			</NuxtLink>
		</div>
		<div class="cart-item-cnt">
			<div class="cart-item-header">
				<div class="cart-item-title">
					<a :href="data.item.url_without_domain">{{ data.item.title }}</a>
				</div>
				<div class="cart-item-info">
					<div class="cart-item-code"><strong>ID:</strong> {{ data.item.code }}</div>
					<div v-if="data.condition && data.condition != 'n'" class="cart-item-condition">
						<span v-html="labels.get('condition_' + data.condition)"></span>
					</div>
				</div>
				<div class="cart-item-actions">
					<BaseWebshopRemoveProduct :item="data" v-slot="{onRemove, loading}">
						<div class="cart-item-remove" :class="{'loading': loading}" @click="onRemove">Obriši</div>
					</BaseWebshopRemoveProduct>
					<BaseWebshopQty :quantity="data.quantity" :limit="data.available_quantity" :item="data" mode="cart" v-slot="{loading, onUpdate, status, quantity}">
						<div class="cart-item-qty" :class="{'loading': loading}">
							<select name="qty" @change="onUpdate">
								<template v-for="(i, index) in 10" :key="index">
									<option :selected="i == quantity" :value="i">{{ i }}</option>
								</template>
							</select>
						</div>
						<div :class="['wp-message', status]" v-if="status"><BaseCmsLabel :code="status" /></div>
					</BaseWebshopQty>
				</div>
				<div class="cart-item-total" :class="{'uau-badge': data.selected_price && data.selected_price == 'uau' && (data.total == (data.gross_amount * data.quantity))}">
					<div v-if="data.discount_amount && (data.gross_amount * data.quantity) != data.total" class="old-price"><BaseUtilsFormatCurrency :price="data.gross_amount * data.quantity" /></div>
					<div :class="['current-price', {'red': data.discount_amount && (data.gross_amount * data.quantity) != data.total}]"><BaseUtilsFormatCurrency :price="data.total" /></div>
					<!--<div class="unit-price" v-if="data.quantity > 1">{{ data.quantity }} x <BaseUtilsFormatCurrency :price="data.unit_price" /></div>-->
				</div>
			</div>
			<div class="cart-item-extras">
				<div class="cart-item-insurances" v-if="availableInsurances.length" @click="selectService('insurance')">
					<div v-if="selectedInsurance" class="cart-item-extra">
						<input type="checkbox" checked />
						<label class="cart-item-extra-title">
							{{ selectedInsurance.title }} za <strong><BaseUtilsFormatCurrency :price="selectedInsurance.price" /></strong>
						</label>
						<span class="cart-item-extra-change"><BaseCmsLabel code="change" /></span>
					</div>
					<div v-else class="cart-item-extra">
						<BaseCmsLabel code="select_insurance" tag="label" class="cart-item-extra-title cart-item-extra-select" />
						<span class="cart-item-extra-change"><BaseCmsLabel code="seller_select" /></span>
					</div>
				</div>

				<div class="cart-item-services" v-if="availableServices.length" @click="selectService('service')">
					<div v-if="selectedServices.length" class="cart-item-extra">
						<input type="checkbox" checked />
						<label class="cart-item-extra-title">
							<span v-for="service in selectedServices" :key="service.code">
								{{ service.title }} za <strong><BaseUtilsFormatCurrency :price="service.price" /></strong>
							</span>
						</label>
						<span class="cart-item-extra-change"><BaseCmsLabel code="change" /></span>
					</div>
					<div v-else class="cart-item-extra">
						<BaseCmsLabel code="select_services" tag="label" class="cart-item-extra-title cart-item-extra-select" />
						<span class="cart-item-extra-change"><BaseCmsLabel code="seller_select" /></span>
					</div>
				</div>

				<WebshopSpecialService :data="data" />
			</div>
			<div v-if="data.errors" class="cart-item-errors">
				<div v-for="error in data.errors" :key="error.label_name" :class="['cart-item-error', {'unavailable': error.qty == 0}]">
					<BaseCmsLabel :code="error.label_name" />
					<template v-if="error.label_name == 'error_available_qty' || error.label_name == 'error_min_order_qty' || error.label_name == 'error_max_order_qty'">{{ error.qty }}</template>
					<template v-if="error.label_name == 'error_price_changed'">
						<div class="btn-edit" @click="priceConfirm()">
							<span><BaseCmsLabel code="cart_error_accept_new_price" /></span>
						</div>
						<div class="price">
							<span class="line-through"><BaseUtilsFormatCurrency :price="error.old_price" /></span>
							<BaseUtilsFormatCurrency :price="error.new_price" />
						</div>
					</template>
				</div>
			</div>
			<div class="cart-item-shippings" v-if="parcel.shipping">
				<template v-for="shipping in data.meta_data.available_shippings" :key="shipping.id">
					<template v-if="shipping.code == 'osobno_preuzimanje'">
						<div :class="['cart-item-shipping', shipping.code]" @click="flyoutStores(shipping, formatDate(shipping.min_date), data.meta_data)">
							{{ shipping.title }}
							<span v-if="data.status == 5"
								>: predvidoma
								<strong>
									{{formatDateSpecial(shipping.min_date)}}
								</strong>
							</span>
							<span v-else-if="shipping.code != 'hitra_dostava'">
								predvidoma od <strong>{{formatDateSpecial(shipping.min_date)}}</strong>
							</span>
						</div>
					</template>
					<div v-else :class="['cart-item-shipping', shipping.code]" @click="flyoutShipping(shipping, formatDateSpecial(shipping.min_date), data.meta_data)">
						<template v-if="shipping.code == 'dostavna_sluzba'"><BaseCmsLabel code="item_delivery_standard_delivery" /></template>
						<template v-else-if="shipping.code == 'dostavna_sluzba_express'"><BaseCmsLabel code="item_delivery_express_delivery" /></template>
						<template v-else-if="shipping.code == 'bigbang_dostavna'"><BaseCmsLabel code="item_delivery_bigbang_delivery" /></template>
						<template v-else-if="shipping.code == 'bigbang_dostavna_xl'"><BaseCmsLabel code="item_delivery_bigbang_xxl_delivery" /></template>
						<template v-else-if="shipping.code == 'hitra_dostava'">
							<BaseCmsLabel code="item_delivery_premium_cart" />
							<strong v-for="fast_shipping_title in shipping.fast_shipping_titles" :key="fast_shipping_title">&nbsp;{{ fast_shipping_title }}*</strong>
						</template>
						<span v-if="data.status == 5"
							>: predvidoma <strong>{{formatDateSpecial(shipping.min_date)}}</strong></span
						>
						<span v-else-if="shipping.code != 'hitra_dostava'">
							predvidoma od <strong>{{formatDateSpecial(shipping.min_date)}}</strong></span
						>
					</div>
				</template>
			</div>
		</div>
	</div>
</template>

<script setup>
	const {formatDate} = useText();
	const labels = useLabels();
	const props = defineProps(['data', 'parcel']);
	const webshop = useWebshop();
	const ep = useEndpoints();
	const {emit} = useEventBus();

	//errors
	const unavailable = computed(() => {
		const e = props.data.errors;
		if (e.length) return props.data.errors[0].qty;
	});

	const availableInsurances = ref([]);
	const selectedInsurance = ref(null);
	const availableServices = ref([]);
	const selectedServices = ref([]);
	const specialService = ref(null);
	const selectedSpecialService = ref(null);
	function watchProps() {
		availableInsurances.value = [];
		selectedInsurance.value = null;
		if (props.data.insurances?.available) {
			props.data.insurances.available.forEach(el => availableInsurances.value.push(el));
		}
		if (props.data.insurances?.selected) {
			props.data.insurances.selected.forEach(el => (selectedInsurance.value = el));
		}
		let specialServiceId = null;
		specialService.value = null;
		availableServices.value = [];
		selectedServices.value = [];
		selectedSpecialService.value = null;
		if (props.data.services?.available) {
			props.data.services.available.forEach(el => {
				if (!el.options?.selected_value) {
					availableServices.value.push(el);
				}
			});
		}
		if (props.data.services?.special) {
			props.data.services.special.forEach(el => {
				specialServiceId = el.id;
				specialService.value = el;
			});
		}
		if (props.data.services?.selected) {
			props.data.services.selected.forEach(el => {
				if (el.id != specialServiceId) {
					selectedServices.value.push(el);
				} else {
					selectedSpecialService.value = el.id;
				}
			});
		}
	}
	watchProps();

	watch(
		() => props.data,
		() => {
			watchProps();
		}
	);

	//flyout shipping
	function flyoutShipping(payload, date, meta) {
		document.body.classList.add('flyout-page', 'cd-flyout-active');

		let payloadId = '';
		let fastShippingTitles = []

		if (payload.code == 'osobno_preuzimanje') {
			payloadId = 'p';
		}
		if (payload.code == 'dostavna_sluzba') {
			payloadId = 's';
		}
		if (payload.code == 'dostavna_sluzba_express') {
			payloadId = 'e';
		}
		if (payload.code == 'bigbang_dostavna') {
			payloadId = 'bb';
		}
		if (payload.code == 'bigbang_dostavna_xl') {
			payloadId = 'bb_xxl';
		}
		if (payload.code == 'hitra_dostava') {
			payloadId = 'bb_fast';
			if (payload.fast_shipping_titles) {
				payload.fast_shipping_titles.forEach(el => {
					fastShippingTitles.push(el);
				});
			}
		}

		const content = {
			shipping_dates: [date],
			date: props.data.shipping_date,
			status: props.data.status,
			shipping_options: [{
				'id': payloadId,
				'fast_shipping_titles': fastShippingTitles
			}]
		};

		emit('flyoutUpdate', {'flyout_mode': 'shipping', 'flyout_content': content ? content : null});
	}

	function flyoutStores(payload, date, meta) {
		document.body.classList.add('flyout-page', 'cd-flyout-active');

		let title = labels.get('item_stores_flyout_title');
		let payloadId = 'p';
		if (props.data.meta_data.available_shippings) {
			props.data.meta_data.available_shippings.some(el => {
				if (el.code === 'hitra_dostava') {
					payloadId = 'bb_fast'
				}
			});
		}

		if(props.data.status == 4 && props.data.warehouses_display) {
			title = labels.get('item_stores_flyout_title')
		}

		//sort locations
		function sortByAvailableQty(a, b) {
			if (a.available_qty > 1 && b.available_qty > 1) {
				return a.title.localeCompare(b.title);
			} else if (a.available_qty === 1 && b.available_qty === 1) {
				return a.title.localeCompare(b.title);
			} else {
				return b.available_qty - a.available_qty;
			}
		}

		props.data.meta_data.available_pickup_locations.sort(sortByAvailableQty);

		let availableLocations = [];
		for (const location of props.data.meta_data.available_pickup_locations) {
			if (location.available_qty > 1) {
				availableLocations.push(location);
			}
		}
		for (const location of props.data.meta_data.available_pickup_locations) {
			if (location.available_qty === 1) {
				availableLocations.push(location);
			}
		}
		for (const location of props.data.meta_data.available_pickup_locations) {
			if (location.available_qty < 1) {
				availableLocations.push(location);
			}
		}

		const content = {
			status: props.data.status,
			warehouses_single_pickup_display: props.data.item.warehouses_single_pickup_display,
			last_piece_sale: props.data.item.last_piece_sale,
			warehouses_display: availableLocations,
			is_available: props.data.is_available,
			shipping_options: [{
				'id': payloadId
			}]
		};

		emit('flyoutUpdate', {'flyout_mode': 'stores', 'flyout_title': title, 'flyout_content': content ? content : null});
	}

	//fast shipping
	const fastShipping = computed(() => {
		let value = false;
		if (props.data.meta_data && props.data.meta_data.available_shippings) {
			props.data.meta_data.available_shippings.some(el => {
				if (el.code === 'hitra_dostava') {
					value = true;
				}
			});
		}
		return value;
	});

	//services select
	const selectService = payload => {
		document.body.classList.add('flyout-page', 'cd-flyout-active');

		const content = {
			cartServiceSelect: true,
			services: availableServices.value ? availableServices.value : [],
			insurances: availableInsurances.value ? availableInsurances.value : [],
			selectedInsurance: selectedInsurance.value ? selectedInsurance.value.id : null,
			selectedServices: selectedServices.value,
			selectedSpecialService: selectedSpecialService.value,
			shopping_cart_code: props.data.shopping_cart_code,
			quantity: props.data.quantity,
		};
		emit('flyoutUpdate', {'flyout_title': (payload == 'insurance') ? labels.get('insurances_flyout_title') : labels.get('services_flyout_title'), 'flyout_mode': payload ? payload : null, 'flyout_content': content ? content : null});
	};

	//confirm price
	async function priceConfirm() {
		//store.loading = 1;
		const cartCode = props.data.shopping_cart_code;
		let itemNewPrice = {};
		if (props.data.errors) {
			props.data.errors.forEach(el => {
				itemNewPrice = el.new_price;
			});
		}
		await useFetch({
			url: endpoints.value._post_hapi_webshop_accept_new_product_price,
			method: 'POST',
			body: {'shopping_cart_code': cartCode, 'accept_price': itemNewPrice},
		}).then(res => {
			if (res.success) {
				webshop.fetchCart();
			}
			//store.loading = 0;
		});
	}

	//date format
	function formatDateSpecial(value) {
		const d = new Date(value)
		const date = (d.getDate() < 9) ? '0' + d.getDate() : d.getDate()
		const day = d.getDay()
		const dayOfWeek = ['nedelje', 'ponedeljka', 'torka', 'srede', 'četrtka', 'petka', 'sobote']
		const month = (d.getMonth() < 9) ? '0' + (d.getMonth() + 1) : (d.getMonth() + 1)

		const dTomorrow = new Date()
		const dToday = new Date()
		let cday
		const tomorrow = dTomorrow
		const today = dToday
		tomorrow.setDate(dTomorrow.getDate() + 1)
		today.setDate(dToday.getDate())
		if (tomorrow.toDateString() === d.toDateString()) {
			cday = 'jutri'
		} else if (today.toDateString() === d.toDateString()) {
			cday = 'danes'
		} else {
			cday = dayOfWeek[day]
		}

		return cday + ', ' + date + '.' + month + '.'
	}
</script>
<style lang="less" scoped>
	.error_limitqty { color: @red2; }
	.cart-item {
		display: flex; position: relative; align-items: flex-start; padding: 20px 150px 20px 30px; border: 1px solid @borderColor;
		@media (max-width: @t) {
			padding: 20px;
		}
		@media (max-width: @m) {
			padding: 10px;
		}
		&:not(:last-child) { border-bottom: 3px solid @borderColor; }
		&.error-item { border: 1px solid @red2; }
	}
	:deep(img) {
		width: auto; height: auto; max-width: 100%; display: block; margin-inline: auto;
		@media (max-width: @t) { max-height: 80px; }
	}
	.cart-item-image {
		width: 120px; flex-grow: 0; flex-shrink: 0;

		@media (max-width: @t) { width: 80px; }
		@media (max-width: @m) { position: absolute; top: 20px; left: 10px; z-index: 10; }
	}
	.cart-item-cnt {
		padding-left: 30px; flex-grow: 1; position: relative;
		@media (max-width: @t) { padding-left: 15px; }
		@media (max-width: @m) { padding: 0; }
	}
	.cart-item-header {
		position: relative; min-height: 55px; margin-bottom: 20px; padding-right: 170px;
		@media (max-width: @t) { padding-right: 0; }
		@media (max-width: @m) { padding-left: 90px; margin-bottom: 20px; }
	}
	.cart-item-title {
		font-weight: 600; line-height: 1.4;
		a {
			color: @textColor; text-decoration: none;
			&:hover { color: @blue; }
		}
	}
	.cart-item-total {
		font-size: 19px; width: 130px; .translate(100%); min-height: 50px; display: flex; flex-direction: column; justify-content: center; font-weight: bold; text-align: right; line-height: 1.3; flex-grow: 0; flex-shrink: 0; position: absolute; top: 0; right: 0;
		&.uau-badge .current-price:not(.blue){color: #f57855;}
		@media (max-width: @t) { .translate(0); bottom: 0; top: auto; }
		@media (max-width: @m) { font-size: 17px; }
	}
	.cart-item-info{
		display: flex; align-items: center; min-height: 27px; margin-top: 7px;

		@media (max-width: @ms){
			display: block; min-height: unset; margin-top: 4px;
		}
	}
	.cart-item-code{font-size: 13px;}
	.cart-item-condition{
		display: inline-flex; align-items: center; justify-content: center; min-height: 27px; margin-left: 10px; padding: 2px 10px; background: #cdd700; border-radius: 14px; font-size: 13px; line-height: 1.3; color: #002d73; font-weight: 600;

		@media (max-width: @ms){margin: 10px 0 2px;}
	}
	.unit-price, .old-price { font-size: 13px; }
	.old-price { text-decoration: line-through; }
	.cart-item-actions {
		display: flex; height: 50px; position: absolute; top: 0; right: 0;
		@media (max-width: @t) { position: relative; margin-top: 20px; }
		@media (max-width: @m) { height: 44px; margin-top: 12px; }
	}
	.cart-item-remove, .cart-item-qty{grid-column: 2;}
	.cart-item-remove {
		width: 50px; display: flex; align-items: center; justify-content: center; flex-grow: 0; flex-shrink: 0; border: 1px solid @borderColor; position: relative; font-size: 0; cursor: pointer; .transition(border-color); z-index: 1; color: @green;
		@media (max-width: @m) { width: 44px; }
		&:hover { border-color: @hoverBorderColor; }
		&:before { .icon-trash(); font: 17px/1 @fonti; .transition(color); }
	}
	select {
		height: 100%; width: 70px; font-size: 14px; padding: 0 25px 0 20px; margin-left: -1px; background-position: right 15px center; position: relative;
		@media (max-width: @m) { width: 60px; padding: 0 15px 0 15px; background-size: 9px auto; }
		&:hover, &:focus { z-index: 1; }
	}
	.cart-item-errors {
		display: block;
		.btn-edit { margin-left: 10px; text-decoration: underline; cursor: pointer; }
		.price { width: 100%; margin-top: 5px; }
	}
	.cart-item-error {
		display: flex; align-items: center; flex-wrap: wrap; margin-bottom: 15px; padding-left: 30px; font-size: 15px; color: @red2; position: relative;
		&:before { .icon-available-last(); font: 17px/1 @fonti; color: @red2; position: absolute; top: 3px; left: 0; }
		&.unavailable:before { .icon-unavailable(); font-size: 15px; }
		@media (max-width: @m) {
			padding-left: 35px; font-size: 14px;
			&:before { left: 5px; }
			.unavailable:before { left: 6px; top: 3px; }
		}
	}
	.cart-item-shippings {
		display: flex; flex-wrap: wrap; font-size: 14px;
		@media (max-width: @m) { padding-left: 5px; }
	}
	.cart-item-shipping {
		position: relative; padding-left: 30px; margin-right: 23px; cursor: pointer; margin-bottom: 10px;
		&:before { .icon-delivery(); font: 16px/1 @fonti; color: @blue; position: absolute; left: 0; top: 2px; }
		&:after { .icon-arrow-down(); font: 10px/1 @fonti; color: @blue; .rotate(-90deg); display: inline-block; width: 10px; height: 10px; margin-left: 5px; .transition(margin); }
		&.osobno_preuzimanje:before { .icon-shop(); font-size: 18px; top: 1px; }
		&:hover:after { margin-right: -5px; }
	}
	.cart-item-unavailable {
		color: @red2; font-weight: bold; position: relative; display: flex; align-items: center; margin-top: 20px;
		&:before { .icon-unavailable(); font: 15px/1 @fonti; margin-right: 8px; }
	}
	.unavailable {
		*:not(.cart-item-cnt, .cart-item-header, .cart-item-actions, .cart-item-remove, .cart-item-errors, .cart-item-error) { opacity: 0.6; pointer-events: none; }
	}
</style>
<style lang="less">
	.cart-item-extras {
		margin-bottom: 25px;
		@media (max-width: @m) { margin-bottom: 15px; }
	}
	.cart-item-extra {
		background: #f3f6fa; padding: 16px; border: 1px solid @borderColor; display: flex; justify-content: space-between; margin-top: -1px;
		label { cursor: pointer; }
		&:hover {
			cursor: pointer;
			.cart-item-extra-change { text-decoration: underline; }
		}
		@media (max-width: @m) { padding: 13px 16px; }
	}
	.cart-item-extra-title {
		flex-grow: 1; padding: 0 0 0 32px !important; position: relative;
		span { display: block; padding: 2px 0; }
	}
	@media (max-width: @m) {
		.cart-item-special .cart-item-extra-title { padding-top: 2px !important; }
		input[type='checkbox'] + label { min-height: 0; }
	}
	.cart-item-extra-select:before { .icon-services-insurance(); font: 25px/1 @fonti; color: @blue; position: absolute; top: -2px; left: 0; }
	.cart-item-services .cart-item-extra-select:before { .icon-storitve(); }
	.cart-item-extra-change {
		color: @blue; font-size: 14px; height: 20px; font-weight: bold; cursor: pointer; position: relative; display: flex; align-items: center; text-decoration: none; line-height: 1; padding-right: 15px; align-self: center;
		@media (max-width: @m) { font-size: 0; }
		&:after { .icon-arrow-down(); font: 9px/1 @fonti; position: absolute; top: 6px; right: 0; .rotate(-90deg); }
	}
</style>
